import React, { Component } from 'react';  
import Util from "../../util.js";
import { Slider, Toast } from 'antd-mobile/lib';
import { protocolCode } from '../../BankCode'
import NavigatorMain from '../NavigatorMain.js';
import { hashHistory } from 'react-router';
import { connect } from 'react-redux';
import { getStorage, setStorage } from "../../common.js";
import { yljycbMoney, yqyljyMoney, yljyAge, yqyljySliderVal, ylOutAge } from "../../action/investmentAction.js";

let interVal = null;

class PensionCalculator extends Component { 
  state = {
    theMoney: this.props.location.query.theMoney ? this.props.location.query.theMoney : this.props.yljycbMoney,
    sliderGetMoneyValue: this.props.location.query.sliderGetMoneyValue ? this.props.location.query.sliderGetMoneyValue : this.props.yqyljyMoney,
    sliderVal: this.props.location.query.sliderVal ? this.props.location.query.sliderVal : this.props.yqyljySliderVal,
    theAge: this.props.location.query.theAge ? this.props.location.query.theAge : this.props.yljyAge,
    thunkIcon: false,
    theOutAge: this.props.location.query.theOutAge ? this.props.location.query.theOutAge : this.props.ylOutAge,
    loadingArr: [require("../../img/theLoading1.png"),
    require("../../img/theLoading2.png"),
    require("../../img/theLoading3.png"),
    require("../../img/theLoading4.png"),
    require("../../img/theLoading5.png"),
    require("../../img/theLoading6.png"),
    require("../../img/theLoading7.png"),
    require("../../img/theLoading8.png"),
    require("../../img/theLoading9.png"),
    require("../../img/theLoading10.png"),
    require("../../img/theLoading11.png"),
    require("../../img/theLoading12.png"),
    require("../../img/theLoading13.png"),
    require("../../img/theLoading14.png"),
    require("../../img/theLoading15.png"),
    require("../../img/theLoading16.png"),
    require("../../img/theLoading17.png"),
    require("../../img/theLoading18.png"),
    require("../../img/theLoading19.png"),
    require("../../img/theLoading20.png"),
    require("../../img/theLoading21.png"),
    require("../../img/theLoading22.png"),
    require("../../img/theLoading23.png"),
    require("../../img/theLoading24.png"),
    require("../../img/theLoading25.png")],
    loadingIcon: ""
  } 

  componentWillMount() {
    window._czc.push(["_trackEvent", "华夏财富H5", "养老智能规划", "进入"]);
    let { dispatch, isLogin } = this.props;
    // getStorage("openFlagYl")
    // .then((data) => {
    //   if(data) {
    //     this.setState({
    //       theMoney: "0",
    //       sliderGetMoneyValue: 5000,
    //       sliderVal: 5000,
    //       theAge: "35",
    //     });
    //     dispatch(yljycbMoney("0"));
    //     dispatch(yqyljyMoney(5000));
    //     dispatch(yqyljySliderVal(5000));
    //     dispatch(yljyAge("35"));
    //     setStorage("openFlagYl", false);
    //   }
    // });
    document.getElementsByTagName('title')[0].innerHTML = "养老智能规划";
    //Toast.loading("正在加载", 0);
    if(isLogin) {
      // dispatch(getUserInfoList(this, (flag, data) => {
      //   if(flag) {
      //     let birthday = returnDate(data.content.birthday+3600000);
      //     let age = returnAge(birthday)
      //     this.setState({
      //       theAge: String(age)
      //     });
      //     dispatch(yljyAge(String(age)));
      //   }else {
      //     this.setState({
      //       theAge: "35"
      //     });
      //     dispatch(yljyAge("35"));
      //   }
      //   Toast.hide();
      // }));
    }else {

    }
  }

  goBack = () => {
    window._czc.push(["_trackEvent", "华夏财富H5", "养老智能规划", "回退"]);
    hashHistory.goBack();
  }

  changeTheMoney = (event) => {
    let { dispatch } = this.props; 
    this.setState({
      theMoney :event.target.value
    })
    dispatch(yljycbMoney(event.target.value));
  }
  changeTheAge = (event) => {
    window._czc.push(["_trackEvent", "华夏财富H5", "养老智能规划", "输入年龄"]);
    let { dispatch } = this.props; 
    this.setState({
      theAge :event.target.value
    })
    dispatch(yljyAge(event.target.value));
  }

  changeTheOutAge = (event) => {
    window._czc.push(["_trackEvent", "华夏财富H5", "养老智能规划", "输入退休年龄"]);
    let { dispatch } = this.props; 
    this.setState({
      theOutAge :event.target.value
    })
    dispatch(ylOutAge(event.target.value));
  }

  changeGetMoney = (value) => {
    window._czc.push(["_trackEvent", "华夏财富H5", "养老智能规划", "输入养老金"]);
    let { dispatch } = this.props; 
    if(value > 10000) {
      let a = (50000 - 10000) / (2000 / 500);
      let b = (value - 10000) / 500;
      this.setState({
        sliderVal: a * b + 10000
      });
      dispatch(yqyljySliderVal(a * b + 10000));
    }else {
      this.setState({
        sliderVal: value
      });
      dispatch(yqyljySliderVal(value));
    }
    this.setState({
      sliderGetMoneyValue: value
    });
    dispatch(yqyljyMoney(value));
  }

  goResult = () => {
    let { theAge, theMoney, sliderVal, theOutAge } = this.state;
    let regAge = /^[0-9]*$/;
    let regMoney = /^(([1-9]\d{0,9})|0)(\.\d{1,2})?$/;
    if(!regAge.test(theAge)) {
      Toast.info( "请输入有效年龄", 2 );
      return;
    }
    if(!regAge.test(theOutAge)) {
      Toast.info( "请输入有效的退休年龄", 2 );
      return;
    }else {
      if(Number(theOutAge) < 30 || Number(theOutAge) > 85) {
        Toast.info( "请输入有效的退休年龄", 2 );
        return;
      }
    }
    if(Number(theAge) >= Number(theOutAge)) {
      Toast.info( "退休年龄需大于您的实际年龄", 2 );
      return;
    }
    if(!regMoney.test(theMoney)) {
      Toast.info( "请输入有效金额", 2);
      return;
    }
    if(sliderVal == 0) {
      Toast.info( "预期养老金不能为0", 2);
      return;
    }
    this.getYearGap(theAge, sliderVal * 12, theMoney, theOutAge, 90 - theOutAge);
  }

  //此处计算器按照每年金额计算，N为预期每年支出的养老金
  getYearGap = (A, N, S, DL, P) => {
    window._czc.push(["_trackEvent", "华夏财富H5", "养老智能规划", "计算结果"]);
    let obj = document.getElementsByTagName("html")[0];
    obj.style.overflowY = "hidden";
    obj.style.overflowY = "hidden";
    obj.addEventListener("touchmove", this.touchMove, false);
    this.setState({
      thunkIcon: true,
      loadingIcon: this.state.loadingArr[0]
    });
    let r = 0.03;
    let r2 = 1/(1+r);
    let ST = S * Math.pow((r+1), (DL-A));
    let N1 = ST / ((1-Math.pow((r2), P)) / (1-(r2)));
    let count = 0;
    interVal = setInterval(() => {
      if(count == 49) {
        clearInterval(interVal);
        this.setState({
          thunkIcon: false
        });
        let obj = document.getElementsByTagName("html")[0];
        obj.style.overflowY = "auto";
        obj.style.overflowY = "auto";
        obj.removeEventListener("touchmove", this.touchMove, false);
        hashHistory.push({
          pathname: "/pensionCalculatorResult",
          state: {
            theParams: {
              actual: N1.toFixed(2), 
              gap: (N-N1).toFixed(2),
              theMoney: Util.parsePrice(N/12, false),
              theAge: A,
              yqylj: this.state.sliderVal,
              theOutAge: DL
            }
          }
        }); 
      }else {
        count++;
        if(count > 24) {
          this.setState({
            loadingIcon: this.state.loadingArr[count - 25]
          });
        }else {
          this.setState({
            loadingIcon: this.state.loadingArr[count]
          });
        }
      }
    }, 100);
  }
  goRule = () => {
    window._czc.push(["_trackEvent", "华夏财富H5", "养老智能规划", "计算规则"]);
    let code=protocolCode["养老计算器规则"];
    hashHistory.push({
        pathname:'/WebView',
        state:{
          name: "养老计算器规则",
          code: code
        },
        query: {
          code: code
        }
    })
  }
  focusTheAge = () => {
    let { dispatch } = this.props;
    if(this.state.theAge == "35") {
      this.setState({
        theAge: ""
      });
      dispatch(yljyAge(""));
    }
  }
  blurTheAge = () => {
    let { dispatch } = this.props;
    if(this.state.theAge == "") {
      this.setState({
        theAge: "35"
      });
      dispatch(yljyAge("35"));
    }
  }
  focusTheOutAge = () => {
    let { dispatch } = this.props;
    if(this.state.theOutAge == "65") {
      this.setState({
        theOutAge: ""
      });
      dispatch(ylOutAge(""));
    }
  }
  blurTheOutAge = () => {
    let { dispatch } = this.props;
    if(this.state.theOutAge == "") {
      this.setState({
        theOutAge: "65"
      });
      dispatch(ylOutAge("65"));
    }
  }
  focusTheMoney = () => {
    let { dispatch } = this.props;
    if(this.state.theMoney == "0") {
      this.setState({
        theMoney: ""
      })
      dispatch(yljycbMoney(""));
    }
  }
  blurTheMoney = () => {
    let { dispatch } = this.props;
    if(this.state.theMoney == "") {
      this.setState({
        theMoney: "0"
      })
      dispatch(yljycbMoney("0"));
    }
  }
  changeMoney = (event) => {
    let reg = /^[0-9]*$/;
    let { dispatch } = this.props;
    if(event.target.value.length <= 7 && reg.test(Util.priceParse(event.target.value))) {
      this.setState({
        sliderVal: Util.priceParse(event.target.value)
      });
      dispatch(yqyljySliderVal(Util.priceParse(event.target.value)));
    }
  }

  componentWillUnmount() {
    window._czc.push(["_trackEvent", "华夏财富H5", "养老智能规划", "退出"]);
    clearInterval(interVal);
    let obj = document.getElementsByTagName("html")[0];
    obj.style.overflowY = "auto";
    obj.style.overflowY = "auto";
    obj.removeEventListener("touchmove", this.touchMove, false);
  }
  touchMove = (event) => {
    event.preventDefault();
  }
  componentDidMount(){
    document.body.scrollTo(0, 0);
  }
  render() { 
    let { theMoney, sliderGetMoneyValue, theAge, sliderVal, theOutAge } = this.state;
    return (  
      <div className="mainBox"> 
        <NavigatorMain>
          <div className="boxHeader bgChange">
            <div>
              <img onClick={this.goBack} src={require("../../img/leftArrow_header.png")} />
            </div>
            <div>
              <span>养老智能规划</span>
            </div>
            <div>
              <span onClick={this.goRule}>计算规则</span>
            </div>
          </div>
        </NavigatorMain> 
        <div className="boxContent" style={{paddingBottom: 20}}>
          <div  className="bgChange2" style={{backgroundSize: "cover",width: window.winWidth, height: "auto", paddingBottom: 20, paddingTop: 20}}>
            <div style={{
              width: window.winWidth,
              paddingLeft: 13,
              paddingRight: 13,
              WebkitFlexDirection: "row",
              WebkitJustifyContent: "space-between",
              WebkitAlignItems: "center",
              display: "-webkit-flex"
            }}>
              <img
              style={{width: 63, height: 63}}
              src={require("../../img/jqrIcon.png")}
              />
              <div style={{paddingRight: 10, paddingTop: 10, paddingBottom: 10, paddingLeft: 15, backgroundColor: "rgba(0, 0, 0, 0.2)", width: window.winWidth-96, borderRadius: 10}}>
                <span style={{
                  color: "#fff",
                  lineHeight: "16px",
                  fontSize: 13
                }}>输入您退休后期望每年获得的养老金收入和目前的储备金状况，算算您的养老金缺口：</span>
              </div> 
            </div>
          </div>
          <div>
            <div style={{
              display: "-webkit-flex",
              height: 45,
              backgroundColor: "#fff",
              paddingLeft: 13,
              paddingRight: 13,
              WebkitAlignItems: "center",
              WebkitFlexDirection: "row",
              borderBottom: "1px solid rgb(235, 238, 240)"
            }}>
              <span style={{
                color: "#000",
                fontSize: "13px",
                width:"50%"
              }}>
                您的年龄
              </span>
              <div style={{display: "-webkit-flex", WebkitFlex: 1, WebkitFlexDirection: "row", WebkitAlignItems: "center"}}>
                <input autocomplete="off"
                style={{
                  height: 40,
                  width:"100%",
                  fontSize: 13,
                  color: "#3a3e47",
                  textAlign: 'right'
                }}
                value={theAge}
                onFocus={this.focusTheAge}
                onBlur={this.blurTheAge}
                onChange={this.changeTheAge}
                placeholder="请输入年龄"
                />
                <span style={{fontSize: 13, color: "#000", paddingLeft: 5}}>
                  岁
                </span>
              </div>
            </div>
            <div style={{
              display: "-webkit-flex",
              height: 45,
              backgroundColor: "#fff",
              paddingLeft: 13,
              paddingRight: 13,
              WebkitAlignItems: "center",
              WebkitFlexDirection: "row",
              borderBottom: "1px solid rgb(235, 238, 240)"
            }}>
              <span style={{
                color: "#000",
                fontSize: "13px",
                width:"50%"
              }}>
                退休年龄
              </span>
              <div style={{display: "-webkit-flex", WebkitFlex: 1, WebkitFlexDirection: "row", WebkitAlignItems: "center"}}>
                <input autocomplete="off"
                style={{
                  height: 40,
                  width:"100%",
                  fontSize: 13,
                  color: "#3a3e47",
                  textAlign: 'right'
                }}
                value={theOutAge}
                onFocus={this.focusTheOutAge}
                onBlur={this.blurTheOutAge}
                onChange={this.changeTheOutAge}
                placeholder="请输入退休年龄"
                />
                <span style={{fontSize: 13, color: "#000", paddingLeft: 5}}>
                  岁
                </span>
              </div>
            </div>
            <div style={{
              display: "-webkit-flex",
              height: 45,
              backgroundColor: "#fff",
              paddingLeft: 13,
              paddingRight: 13,
              WebkitAlignItems: "center",
              WebkitFlexDirection: "row",
              borderBottom: "1px solid rgb(235, 238, 240)"
            }}>
              <span style={{
                color: "#000",
                fontSize: "13px",
                width:"50%"
              }}>
                当前养老储备金
              </span>
              <div style={{display: "-webkit-flex", WebkitFlex: 1, WebkitFlexDirection: "row", WebkitAlignItems: "center"}}>
                <input autocomplete="off"
                style={{
                  height: 40,
                  width:"100%",
                  fontSize: 13,
                  color: "#3a3e47",
                  textAlign: 'right'
                }}
                value={theMoney}
                onFocus={this.focusTheMoney}
                onBlur={this.blurTheMoney}
                onChange={this.changeTheMoney}
                placeholder="请输入金额"
                />
                <span style={{fontSize: 13, color: "#000", paddingLeft: 5}}>
                  元
                </span>
              </div>
            </div>
          </div>
          <div
          style={{display: "-webkit-flex", backgroundColor: "rgb(235, 238, 240)", height: 80, WebkitJustifyContent: "center", WebkitAlignItems: "center", paddingLeft: 13, paddingRight: 13}}
          >
            <span style={{
              color: "#5b6270",
              lineHeight: 1.5,
              display: "block",
              fontSize: "13px"
            }}>
              养老储备金是指您当前计划用于养老的储备金，一般是指银行存款、企业年金、社保及养老补充商业保险等。
            </span>
          </div>
          <div style={{paddingTop: 20, paddingBottom: 20, paddingLeft: 13, paddingRight: 13, backgroundColor: "#fff"}}>
            <div style={{WebkitFlexDirection: 'row', WebkitAlignItems: "center", height: 50, display: "-webkit-flex"}}>
              <span style={{color: "#3a3e47", fontSize: 12}}>您预期养老金</span><div style={{marginTop: -15, borderBottom: "1px solid #fa063a"}}><input autocomplete="off" type="text" onChange={this.changeMoney} style={{color: "#fa063a", fontSize: 22, width: 90, padding: 0, textAlign: "center"}} value ={Util.parsePrice(sliderVal, false) == 0.00 ? "0" : Util.parsePrice(sliderVal, false)} /></div><span style={{color: "#3a3e47", fontSize: 12}}>元／月</span>
            </div>
            <div style={{paddingTop: 20, textAlign: "center"}}>
              <Slider trackStyle={{backgroundColor: "transparent", width: window.winWidth - 34}} railStyle={{backgroundColor: "transparent"}} handleStyle={{backgroundColor: "transparent", border: 0, "boxShadow": "none", backgroundSize: "contain", backgroundRepeat: "no-repeat", backgroundPosition: "center", height: 30, width: 25, border: 0, backgroundImage: `url(${require("../../img/huakuai.png")})`}} step={500} defaultValue={sliderGetMoneyValue} min={0} max={12000} onChange={this.changeGetMoney} />
              <img
              src={require("../../img/huatiao7.png")}
              style={{width: window.winWidth-49, marginTop: 25}}
              />
              <div style={{margin: "0 auto", width: window.winWidth - 29, WebkitJustifyContent: "space-between", WebkitFlexDirection: "row", display: "-webkit-flex"}}>
                <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>0k</span>
                <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>2k</span>
                <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>4k</span>
                <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>6k</span>
                <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>8k</span>
                <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>1w</span>
                <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>5w</span>
              </div>
            </div>
          </div>
          <div
          style={{display: "-webkit-flex", backgroundColor: "#fff", WebkitJustifyContent: "center", WebkitAlignItems: "center", paddingLeft: 13, paddingRight: 13, marginTop: 10, paddingTop: 20, paddingBottom: 20}}
          >
            <span style={{
              color: "#5b6270",
              lineHeight: 1.5,
              display: "block",
              fontSize: "13px"
            }}>
              温馨提示 : 试算年化收益率仅用于智投组合方案测算，并不代表某个智投组合的收益表现。
            </span>
          </div>
          <div style={{WebkitJustifyContent: "center", WebkitAlignItems: "center", marginTop: 10, display: "-webkit-flex"}}>
            {
              theAge != "" && theAge != null && theAge != undefined && theMoney != "" && theMoney != null && theMoney != undefined ?
              <div onClick={this.goResult} style={{backgroundColor: "#fa063a", WebkitJustifyContent: "center", WebkitAlignItems: "center", height: 40, width: window.winWidth - 26, borderRadius: 30, display: "-webkit-flex"}}>
                <span style={{color: "#fff", fontSize: 14}}>诊断养老投资状况</span>
              </div> :
              <div style={{backgroundColor: "#afb0b2", WebkitJustifyContent: "center", WebkitAlignItems: "center", height: 40, width: window.winWidth - 26, borderRadius: 30, display: "-webkit-flex"}}>
                <span style={{color: "#fff", fontSize: 14}}>诊断养老投资状况</span>
              </div>
            }
          </div>
        </div>
        {
          !this.state.thunkIcon ? null :
          <div style={{position:'fixed', left:0, bottom: 0, width: window.winWidth, backgroundColor: "rgba(0, 0, 0, 0.7)", WebkitJustifyContent: "center", WebkitAlignItems: "center", top: window.navigator.userAgent.indexOf("amcfmapp") > -1 || window.navigator.userAgent.indexOf("hxcfH5WX") > -1 || window.navigator.userAgent.match(/MicroMessenger/i) == "micromessenger" ? 0 : 44, display: "-webkit-flex", WebkitFlexDirection: "column"}}>
            <img
            src={this.state.loadingIcon}
            style={{width: 250, height: 250, marginTop: -80}}
            />
            <span style={{marginTop: 25, fontSize: 18, color: "#fff"}}>运算中...</span>
          </div>
        }
      </div>  
    );  
  }  
}  

function mapStateToProps(state, ownProps) {
  return {
    yljycbMoney: state.yljycbMoney,
    yqyljyMoney: state.yqyljyMoney,
    yljyAge: state.yljyAge,
    ylOutAge: state.ylOutAge,
    yqyljySliderVal: state.yqyljySliderVal,
    isLogin: state.isLogin
  }
}
  
export default connect(mapStateToProps)(PensionCalculator);


// WEBPACK FOOTER //
// ./src/components/recommend/PensionCalculator.js